import { render, staticRenderFns } from "./SearchMainSection.vue?vue&type=template&id=65403e60&scoped=true&"
import script from "./SearchMainSection.vue?vue&type=script&lang=js&"
export * from "./SearchMainSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchMainSection.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SearchMainSection.vue?vue&type=style&index=1&id=65403e60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65403e60",
  null
  
)

export default component.exports